import type { GameTheme } from "@skillscratch/shared-types";
import background from "./background.webp";
import name from "./name.webp";
import overlay from "./overlay.webp";

export const canyonCash = {
  id: "canyon-cash",
  name: "Canyon Cash",

  colorScheme: {
    tileColors: [
      { background: "#f15e16", text: "#fff" },
      { background: "#cf4501", text: "#fff" },
      { background: "#ad3900", text: "#fff" },
      { background: "#862c00", text: "#fff" },
    ],
    overlayPattern: overlay,
    overlayColor: "#622000",
    scratchColor: "#cf4501",

    controlColor: "#cf4501",
    onControlColor: "#fff",
  },

  nameImage: name,
  background: background,
  card: background,

} satisfies GameTheme;
